'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './sidebar-teaser.component';
import dynamic from 'next/dynamic';

const DynamicSidebarTeaserComponent: ComponentType<Props> = dynamic(
  () => import('./sidebar-teaser.component')
);

export default DynamicSidebarTeaserComponent;

export function calculateSidebarTeaserPlaceholderConfig(): PlaceholderConfig {
  return { heightSinceWidth: [{ sinceWidth: 389, height: 264 }] };
}
